export function isCustomerType(type: string) {
    if( type == "PATIENT") {
      return true;
    }
    return false
}

export function isVendorType(type: string) {
     
    if( type == "DOCTOR" 
       || type == "CLINIC" 
       || type == "HOSPITAL"
       || type == "LAB" 
       || type == "PHARMACY" 
       ) {
        return true;
      }
      return false
}

export function isAdminType(type: string) {
    if(
         type == "ADMIN" 
         || type == "SUPER_ADMIN") {
        return true;
      }
      return false
}

export function isValidType(type: string) {
  if(  type == "PATIENT"
       || type == "ADMIN" 
       || type == "SUPER_ADMIN"
       || type == "DOCTOR" 
       || type == "CLINIC" 
       || type == "HOSPITAL"
       || type == "LAB" 
       || type == "PHARMACY" 
       ) {
      return true;
    }
    return false
}